/**
 * 游戏权重配置
 * 权重值越大，排序越靠前
 */

export interface IGameWeightConfig {
  [gameCode: string]: number;
}

/**
 * 游戏权重配置对象
 * 当前配置：
 * - i_game: 权重最高 (100)
 * - 其他游戏: 默认权重 (0)
 */
export const GAME_WEIGHTS: IGameWeightConfig = {
  'i_game': 100,
  // test 用于测试环境自测
  // 'test': 99,
};

/**
 * 默认权重值
 * 当游戏代码不在权重配置中时使用此值
 */
export const DEFAULT_GAME_WEIGHT = 0;

/**
 * 获取游戏权重值
 * @param gameCode - 游戏代码
 * @returns 权重值
 */
export const getGameWeight = (gameCode: string): number => {
  return GAME_WEIGHTS?.[gameCode] ?? DEFAULT_GAME_WEIGHT;
};

